import { render, staticRenderFns } from "./showSetting.vue?vue&type=template&id=346007c0&scoped=true"
import script from "./showSetting.vue?vue&type=script&lang=js"
export * from "./showSetting.vue?vue&type=script&lang=js"
import style0 from "./showSetting.vue?vue&type=style&index=0&id=346007c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346007c0",
  null
  
)

export default component.exports